
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ef9a9d86&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CreditRecords.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CreditRecords.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ef9a9d86!../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CreditRecords.vue"),
  /* scopeId */
  "data-v-ef9a9d86",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/backoffice/tabbed/CreditRecords.vue
// module id = 1988
// module chunks = 1